<script setup lang="ts">
import { ref, computed, watch } from "vue";
import { storeToRefs } from "pinia";
import { useRouter, useRoute } from "vue-router";
import { ROUTE_NAMES } from "@/router/routes";
import { useTerminalsStore } from "@/stores/terminals";
import { useUiStore } from "@/stores/ui";

const router = useRouter();
const route = useRoute();

const uiStore = useUiStore();
const terminalsStore = useTerminalsStore();

const { activeTerminal } = storeToRefs(terminalsStore);
const { rail } = storeToRefs(uiStore);

const routes = ref(
  router.options.routes.filter(
    (t) => t.name === ROUTE_NAMES.TERMINAL_DATA_INDEX,
  )[0].children,
);
const routeParent = computed(() => {
  const parent = routes.value?.filter(
    (r) =>
      r.name === route.name || r.children?.find((c) => c.name === route.name),
  );
  return parent && parent.length > 0
    ? [parent[0].name as string]
    : [ROUTE_NAMES.TERMINAL_DATA_TERMINAL_INFORMATION];
});

const open = ref(rail.value ? [] : routeParent.value);
watch(
  rail,
  (data) => {
    open.value = data === true ? [] : routeParent.value;
  },
  { immediate: true },
);

const show = computed(() => {
  const isValidTerminalDataRoute = routes.value?.find(
    (r) =>
      r.name === route.name || r.children?.find((c) => c.name === route.name),
  );
  return typeof isValidTerminalDataRoute !== "undefined";
});

const handleRoute = (path, name) => {
  return {
    name: name,
    params: {
      terminalId: activeTerminal.value?.id,
    },
  };
};
</script>
<template>
  <v-list v-if="show" v-model:opened="open" expand nav :selected="route.name">
    <template v-for="(item, i) in routes" :key="i">
      <v-list-group no-action color="orange" :value="item.name as string">
        <template #activator="{ props }">
          <v-list-item
            v-bind="props"
            :prepend-icon="item.meta?.icon as string"
            class="pl-0"
            color="orange"
          >
            <v-list-item-title class="parent-title">
              {{ item.meta?.title as string }}
            </v-list-item-title>
          </v-list-item>
        </template>
        <template v-for="(subItem, j) in item.children" :key="j">
          <v-list-item
            :id="subItem.meta?.title"
            color="orange"
            :to="handleRoute(item.path + '/' + subItem.path, subItem.name)"
            :title="subItem.meta?.title as string"
            :value="subItem.name"
          />
        </template>
      </v-list-group>
    </template>
  </v-list>
</template>

<style lang="scss" scoped>
:deep(.v-list-item) {
  font-family: "Montserrat", sans-serif;
  font-size: 16px;
  color: white;
}

.parent-title {
  font-weight: bolder !important;
  font-size: 16px !important;
}

:deep(.v-list-item--disabled) {
  color: rgb(94, 94, 94) !important;
}
:deep(.v-list-item--active) {
  color: orange !important;
}
</style>
